import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { JDProcessingStatus } from '../../types';
import { JD_PROCESSING_STATUS_CONFIG } from '../../types';

export function ProcessingStatusBadge({ status }: { status: JDProcessingStatus }) {
  const { t } = useTranslation('ats');
  const config = JD_PROCESSING_STATUS_CONFIG[status] ?? { label: status, color: 'gray' as const };
  const label = t(`jdProcessingStatus.${status === 'error' ? 'failed' : status}`);
  const colorClasses = {
    yellow: 'bg-yellow-100 text-yellow-700',
    blue: 'bg-blue-100 text-blue-700',
    green: 'bg-green-100 text-green-700',
    red: 'bg-red-100 text-red-700',
    gray: 'bg-gray-100 text-gray-700',
  };
  const dotClasses = {
    yellow: 'bg-yellow-500',
    blue: 'bg-blue-500',
    green: 'bg-green-500',
    red: 'bg-red-500',
    gray: 'bg-gray-500',
  };
  const color = config.color as keyof typeof colorClasses;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${colorClasses[color]}`}>
      {status === 'processing' ? (
        <Loader2 className="w-3 h-3 mr-1.5 animate-spin" />
      ) : (
        <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${dotClasses[color]}`} />
      )}
      {label || config.label}
    </span>
  );
}
